import { IIconProps } from '@cian/ui-kit/icons/internal/types';
import { mergeStyles } from '@cian/utils/lib/shared/style';
import * as React from 'react';

import * as styles from './index.css';

interface ITab {
  className?: string;
  isActive: boolean;
  icon: React.FC<IIconProps>;
  onClick(): void;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

export const Tab = React.forwardRef<HTMLLIElement, ITab>(
  ({ onClick, className, isActive, icon: Icon, children, style }, ref) => {
    return (
      <li
        {...mergeStyles([styles['tab'], className, isActive && styles['active']])}
        onClick={onClick}
        style={style}
        ref={ref}
      >
        <Icon />
        {children}
      </li>
    );
  },
);

Tab.displayName = 'Tab';
